import type { en } from "./en";

// Finnish translations. Missing keys fall back to English via i18next.
export const fi: typeof en = {
  common: {
    home: "Etusivu",
    no_scores: "Ei vielä pisteitä",
    points_count_one: "{{count}} piste",
    points_count_other: "{{count}} pistettä",
    questions_count_one: "{{count}} kysymys",
    questions_count_other: "{{count}} kysymystä",
  },
  home: {
    placeholder: "Pelikoodi",
    enter: "Liity",
    error_invalid_code: "Syötä opettajaltasi saamasi 6 merkin pelikoodi.",
    footer: "Käynnistä Binogi Buzz Binogi.com-tuotteista.",
    language_label: "Kieli",
  },
  errors: {
    generic: "Jokin meni pieleen. Yritä uudelleen.",
    stale_client: "Sivu on vanhentunut – päivitä se.",
    session_not_found: "Peliä ei löytynyt.",
    session_not_open: "Tämä peli on päättynyt.",
    session_not_active: "Tämä kysymys tai peli on jo päättynyt.",
    not_teacher: "Vain opettaja voi tehdä sen.",
    already_answered: "Olet jo vastannut tähän kysymykseen.",
    wrong_question_index: "Tämä kysymys ei ole vielä alkanut.",
    name_taken: "Nimi on jo käytössä. Kokeile toista.",
    character_busy: "Emme saaneet sinulle hahmoa juuri nyt – yritä uudelleen.",
  },
  host: {
    input: {
      heading: "Käynnistä Buzz",
      lead:
        "Syötä sen Binogi-oppitunnin koodi, jota oppilaasi opiskelevat. Lataamme kysymykset ja luomme pelin, jonka voit heijastaa taululle.",
      lesson_code_label: "Oppitunnin koodi",
      placeholder_code: "BIH750",
      load_button: "Lataa oppitunti",
      try_hint: "Kokeile:",
      error_invalid_code: "Syötä Binogi-oppitunnin koodi, esim. BIH750.",
      error_not_found: "Koodilla {{code}} ei löytynyt oppituntia.",
      error_unreachable: "Oppituntipalvelimeen ei saatu yhteyttä. Tarkista yhteytesi ja yritä uudelleen.",
      error_no_questions: "Oppitunnilla {{code}} ei ole kysymyksiä, joita Buzz voi käyttää.",
      error_no_level_questions: "Oppitunnilla {{code}} ei ole valitun tason kysymyksiä.",
    },
    loading: "Ladataan oppituntia…",
    placeholder_title: "Käynnistä Binogi Buzz",
    tab_details: "Tiedot",
    tab_questions: "Kysymykset",
    settings: "Asetukset",
    number_of_students: "Oppilaiden määrä",
    fewer_students: "Vähemmän oppilaita",
    more_students: "Enemmän oppilaita",
    player_names: "Pelaajien nimet",
    player_anonymous: "Anonyymi",
    player_self_chosen: "Oppilaat valitsevat",
    language: "Kieli",
    language_teacher: "Opettaja valitsee",
    language_students: "Oppilaat valitsevat",
    time_per_question: "Aika kysymystä kohden",
    time_option: "{{seconds}} s",
    start_button: "Käynnistä peli",
    start_disabled: "Valitse luokan koko aloittaaksesi",
    creating: "Luodaan peliä…",
    error_no_questions: "Säilytä vähintään yksi kysymys ennen aloittamista.",
    error_create_failed: "Pelin luonti epäonnistui",
    error_load_failed: "Oppitunnin lataus epäonnistui",
    no_session: "Peliä ei ole käynnissä.",
    back_to_review: "Takaisin kysymyksiin",
    errors: {
      dismiss: "Sulje",
      refresh: "Päivitä",
      attach_failed: "Tämä näyttö ei saanut yhteyttä opettajana.",
      unreachable: "Palvelimeen ei saatu yhteyttä. Päivitä sivu ja yritä uudelleen.",
      no_token: "Tämä välilehti ei voi enää ohjata visaa. Avaa Buzz oppitunniltasi aloittaaksesi uuden pelin.",
      taken_over: "Tätä visaa ohjataan nyt toiselta näytöltä.",
      stale_question: "Buzz päivittyi tämän visan aikana, joten tämä näyttö ei voi jatkaa sitä. Päivitä sivu, niin visa jatkuu siitä, missä luokka on.",
      question_moved_on: "Visa on jo edennyt, joten tämä näyttö on jäljessä. Päivitä sivu, niin visa jatkuu siitä, missä luokka on.",
    },
    entry: {
      opening: "Avataan opettajan näkymää…",
      token_title: "Tätä opettajan linkkiä ei voi avata",
      token_body: "Linkistä puuttuu opettajan avain tai se on vanhentunut. Avaa Buzz oppitunniltasi luodaksesi uuden pelin.",
      not_found_title: "Peliä ei löytynyt",
      not_found_body: "Tätä visapeliä ei ole enää olemassa. Luo uusi jatkaaksesi.",
      back: "Takaisin alkuun",
    },
    questions: {
      drag_aria: "Vedä järjestääksesi",
      remove_aria: "Poista kysymys",
      empty: "Tässä pelissä ei ole enää kysymyksiä.",
      add: "Lisää",
      add_aria: "Lisää kysymys: {{text}}",
      add_all: "Lisää kaikki",
      add_all_n: "Lisää kaikki {{count}} kysymystä",
      more_one: "{{count}} kysymys lisää tässä oppitunnissa",
      more_other: "{{count}} kysymystä lisää tässä oppitunnissa",
      level_easy: "Helppo",
      level_medium: "Keskitaso",
      level_hard: "Vaikea",
      multi: "Monivalinta",
    },
    lobby: {
      go_to: "Mene osoitteeseen <strong>buzz.binogi.com</strong> ja syötä:",
      or_qr: "…tai skannaa QR-koodi",
      students_joined_of: "{{joined}} / {{expected}} oppilasta liittynyt",
      students_joined_one: "{{count}} oppilas liittynyt",
      students_joined_other: "{{count}} oppilasta liittynyt",
      waiting: "Odotetaan oppilaiden liittymistä…",
      start_game: "Aloita peli",
      connected: "Yhdistetty",
      connecting: "Yhdistetään…",
      copy_link: "Kopioi linkki",
      copy_link_copied: "Kopioitu!",
    },
    question: {
      header: "Kysymys {{index}} / {{total}}",
      level: "Taso {{level}}",
      none: "Ei aktiivista kysymystä.",
      answered: "Vastannut",
      top_n: "Top {{count}}",
      answers_heading: "Vastaukset",
      end_question: "Lopeta kysymys",
      next_question: "Seuraava kysymys",
      see_results: "Näytä lopputulokset",
    },
    results: {
      heading: "Lopputulokset",
      all_players: "Kaikki pelaajat",
      end_session: "Lopeta peli",
      new_session: "Uusi peli",
      none: "Tässä pelissä ei ole pelaajia.",
    },
  },
  join: {
    code_label: "Pelikoodi",
    name_label: "Nimesi",
    name_placeholder: "Kirjoita nimesi",
    join_button: "Liity",
    joining: "Liitytään…",
    checking: "Tarkistetaan…",
    character_hint: "Saat hauskan Binogi-hahmonimen, kun liityt.",
    error_not_found:
      "Tämä koodi ei vielä vastaa aktiivista peliä. Tarkista se opettajalta.",
    error_lookup_failed: "Pelin haku epäonnistui",
    error_code_required: "Syötä 6 merkin koodi.",
    error_name_required: "Kirjoita nimesi.",
  },
  play: {
    superseded: "Olet yhdistettynä toisessa välilehdessä — sulje se jatkaaksesi pelaamista täällä.",
    back_to_join: "Takaisin liittymiseen",
    no_round: "Ei kierroksen tietoja.",
    not_joined: "Et ole liittynyt peliin.",
    no_question: "Ei aktiivista kysymystä.",
    keep_awake_hint: "Napauta näyttöä, niin se pysyy päällä",
    waiting: {
      you_are: "Olet",
      get_ready_named: "Valmistaudu, {{name}}!",
      get_ready: "Valmistaudu visaan!",
      in_room_label: "Oppilaita huoneessa",
      in_room_one: "{{count}} oppilas huoneessa",
      in_room_other: "{{count}} oppilasta huoneessa",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Vastattu!",
      times_up: "Aika loppui",
      submit: "Vastaa",
      submit_n: "Vastaa {{count}} valinnalla",
    },
    between: {
      correct: "Oikein!",
      wrong: "Melkein!",
      times_up: "Aika loppui",
      points_gained: "+{{count}} pistettä",
      your_score: "Pisteesi",
      your_rank: "Sijalla {{rank}}",
      top_n: "Top {{count}}",
      waiting_next: "Odotetaan seuraavaa kysymystä…",
    },
    finished: {
      heading: "Kiitos kun pelasit Binogi Buzzia!",
      your_final_rank: "Lopullinen sijoituksesi",
      top_n: "Top {{count}}",
      none: "Ei näytettäviä tuloksia.",
    },
  },
  characters: {
    heading: "Binogi-hahmot",
    lead: "{{count}} oppilasta saa hahmon liittyessään, tässä järjestyksessä.",
  },
};
